import React, { useCallback, useEffect, useState, useMemo } from 'react';  
import { message } from 'antd';
import { TableTransfer } from '../../tableTransfer/TableTransfer';
import { useAllTagsQuery } from '../../../gql/hooks';

const TagSelector = ( props ) => {
    
    const [ targetKeys, setTargetKeys ] = useState( [] );

    /*************************
     * Fetch tags handling  
     ************************/ 
    
    const [ tagsList, setTagsList ] = useState( [] );
    
    const { data: tagsData, loading: tagsLoading, error: tagsError } = useAllTagsQuery( { fetchPolicy: 'network-only' } );
    
    useEffect( () => {
        if ( tagsData && !tagsError ) {
            // Remove everything except the array of tags from tagsData
            const cleanedData = tagsData.tags?.edges?.map( i => ( { ...i.node, key: i.node.id, label: i.node.name } ) );
            
            setTagsList( cleanedData );
        } else {
            if ( tagsError ) {
                message.error( 'An error occurred loading tags!' );
            }
        }
    }, [ tagsData, tagsError ] );
    
    /****************************
     * Event handling
     ***************************/ 
 
    const handleTransfer = useCallback( ( nextTargetKeys, direction, moveKeys ) => {
        setTargetKeys( nextTargetKeys );

        if ( props.onChange ) {
            props.onChange( nextTargetKeys, direction, moveKeys );
        }
    }, [ setTargetKeys, props ] );
 
    const handleReorder = useCallback( ( reorderedTargetKeys, reorderedData ) => {
        setTargetKeys( reorderedTargetKeys );

        if ( props.onReorder ) {
            props.onReorder( reorderedTargetKeys, reorderedData );
        }
    }, [ props ] );

    /****************************
     * Column for table
     ***************************/ 
 
    const columns = useMemo( () => ( [
        {
            dataIndex: 'label',
            title: 'Name',
            render: ( text ) => {
                return ( <span>{ text }</span> );
            }
        }
    ] ), [] );

    /****************************
     * Render
     ***************************/ 
 
    return (
        <TableTransfer
            titles={ [ 'Available', 'Selected' ] }
            dataSource={ tagsList }
            targetKeys={ targetKeys }
            sourceColumns={ columns }
            targetColumns={ columns } 
            loading={ tagsLoading }
            disabled = { props.disabled }
            onChange={ handleTransfer }
            onReorder={ handleReorder }
            reorderable={ false }
            showSearch
            filterOption={ ( inputValue, item ) => {
                const inputLowerCase = inputValue.toLowerCase();
                const itemLabel = ( item?.label || '' ).toLowerCase();
                const itemId = ( item?.id || '' ).toLowerCase();

                const isLabelMatch = ( itemLabel.indexOf( inputLowerCase ) !== -1 );
                const isId = ( itemId === inputLowerCase );
                return ( isLabelMatch || isId );
            } }
            listStyle={ {
                height: 400,
            } }
            { ...props }
        />
    );
};

export default TagSelector;
